<template>
  <div>
    <div class="latest-activity" v-if="AnnouncementList && AnnouncementList.length">
      <div class="latest-activity__title">
        <h1>更新公告</h1>
        <el-button class="move-btn" type="text" @click="handleMoveBtn">查看更多></el-button>
      </div>

      <div class="latest-activity__content">
        <div class="activeDiv" style="margin-bottom: 18px;justify-content: flex-start;"
          v-for="(item,index) in AnnouncementList" :key="index">
          <div class="tag">更新</div>
          <div class="tag-text" @click="handleAnnouncement(item)">{{ item.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getNoteActiveByType ,getReadVersion} from '@/utils/api/dashboard';
import { onlineUrl } from '@/utils/config';
export default {
  data() {
    return {
      AnnouncementList: []
    }
  },
  components: {

  },
  mounted() {
    this.getNoteActiveByTypeFn()
  },
  methods: {
    async getReadVersionFn(data) {
      try {
        const params = { id: data }
        const res = await getReadVersion(params)
      } catch (error) {
        console.log(error)
      }
    },
    async handleAnnouncement(item) {
        await this.getReadVersionFn(item.id)
        if (item.linkUrl) {
          window.location.href = item.linkUrl
        } else if (item.hashCode&&!item.linkUrl) {
          window.location.href = `${onlineUrl}/note/preview?id=${item.hashCode}&&detailid=${item.id}`
        } else {
          window.location.href = `${onlineUrl}/purchase-order/supplier/AnnouncementDetails/${item.id}`
        }
    },
    handleMoveBtn() {
      window.location.href =`${onlineUrl}/purchase-order/supplier/AnnouncementList`
    },
    getNoteActiveByTypeFn() {
      getNoteActiveByType({ type: 9, site: 0, curPage: 1, pageSize: 5 }).then(res => {
        if (res.rspResult.bizCode == 200) {
          this.AnnouncementList = res.rspPageData.list
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.latest-activity {
  background-color: #fff;
  padding: 0 16px 16px;
  margin: 8px 0;

  .latest-activity__title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 0;

    h1 {
      color: #304a66;
      font-family: 'SourceHanSansCN-Regular';
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
    }

    .move-btn {
      color: #8492a6 !important;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }

    .move-btn:hover {
      color: #066EB7 !important;
    }
  }

  .latest-activity__content {
    .activeDiv {
      display: flex;
      justify-content: space-between;
      margin-bottom: 14px;

      .tag {
        display: flex;
        padding: 0 8px;
        justify-content: center;
        align-items: center;
        border-radius: 2px;
        background: #EDF7FE;
        color: #0052d9;
        font-family: 'SourceHanSansCN-Regular';
        font-size: 12px;
        font-weight: 400;
        white-space: nowrap;
        margin-right: 8px;
      }

      .tag-text {
        overflow: hidden;
        font-family: 'SourceHanSansCN-Regular';
        color: #304a66;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        cursor: pointer;
      }

      .tag-text:hover {
        color: #066eb7;
      }
    }

    .activeDiv:last-child {
      margin-bottom: 0 !important;
    }
  }

}
</style>
